// views/Profile/components/NotEnterpriseEmptyState.jsx
import React from 'react';
import { Building2, ArrowUpRight } from 'lucide-react';
import './NotEnterpriseEmptyState.css';

/**
 * NotEnterpriseEmptyState — neutral notice shown on the Organization
 * tab when the active org has no Enterprise subscription. Triggered
 * either by a `404 NOT_AN_ENTERPRISE_ORG` from the org-balance call
 * or by a fast-path check on `isEnterprisePool === false`.
 *
 * Optional `onContactSales` opens the Subscription view's contact
 * dialog so admins can request an upgrade. Wired by the parent.
 */
export default function NotEnterpriseEmptyState({
  organizationName,
  onContactSales,
}) {
  return (
    <div className="not-enterprise" role="status">
      <div className="not-enterprise__icon">
        <Building2 size={36} aria-hidden="true" />
      </div>
      <h2 className="not-enterprise__title">
        Not on an Enterprise plan
      </h2>
      <p className="not-enterprise__body">
        {organizationName ? (
          <>
            <strong>{organizationName}</strong> uses per-account
            billing today. Each member sees their own balance under
            "My account".
          </>
        ) : (
          <>
            This organization uses per-account billing today. Each
            member sees their own balance under "My account".
          </>
        )}
        {' '}
        Enterprise unlocks a shared pool, custom allowance and the
        usage-by-account breakdown on this tab.
      </p>
      {onContactSales && (
        <button
          type="button"
          className="not-enterprise__cta"
          onClick={onContactSales}
        >
          Contact sales
          <ArrowUpRight size={14} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
